import { createRequire } from "node:module";
const detectTypesProvider = async (config = {}) => {
  const cwd = config.cwd || process.cwd();
  const require2 = createRequire(cwd.endsWith("/") ? cwd : cwd + "/");
  try {
    if (Number.parseInt(require2("@prismicio/client/package.json").version.split(".")[0]) >= 7) {
      return "@prismicio/client";
    }
  } catch {
  }
  try {
    require2.resolve("@prismicio/types");
    return "@prismicio/types";
  } catch {
  }
};
export {
  detectTypesProvider
};
//# sourceMappingURL=detectTypesProvider.js.map
